import { render, staticRenderFns } from "./persons.htm?vue&type=template&id=3865d812&external"
import script from "./persons.vue?vue&type=script&lang=js"
export * from "./persons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports